import { InjectionToken } from '@angular/core';
import type { PlatformApiConfig } from './api.config';

export const PlatformApiConfigToken = new InjectionToken<PlatformApiConfig>('PlatformApiConfig');
